<template>
  <!-- 没有在APP找到这个页面，可能被废弃了。 -->
  <div class="invite-wrap">
    <div class="main">
      <div class="header">
        <div class="h1">邀请好友赚余额</div>
        <div class="h2">
          好友注册，好友立即获得￥<span
            v-if="inviteInfo.max_reduce"
            v-text="inviteInfo.max_reduce / 100"
          ></span
          >优惠券
        </div>
        <div class="h2">
          好友首次支付『您』立即获得￥<span
            v-if="inviteInfo.invite_balance"
            v-text="inviteInfo.invite_balance / 100"
          ></span
          >余额奖励
        </div>
      </div>

      <div class="first-page">
        <div class="title">
          <div class="ycode" v-text="inviteInfo.user_code"></div>
        </div>

        <p class="info">您的专属邀请码</p>
        <p class="info">新注册好友可在“我的-优惠券”内兑换</p>

        <div class="h3">
          <span>—</span>&nbsp;&nbsp;&nbsp;邀请好友&nbsp;&nbsp;&nbsp;<span
            >—</span
          >
        </div>

        <div class="share">
          <a v-if="inviteInfo && haswx == 1" @click="share(1)"
            ><img src="../../static/img/timeline.png" alt="timeline"
          /></a>
          <a v-if="inviteInfo && haswx == 1" @click="share(2)"
            ><img src="../../static/img/friendmsg.png" alt="friendmsg"
          /></a>
          <a v-if="inviteInfo" @click="share(3)"
            ><img src="../../static/img/weibo.png" alt=""
          /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../services/tools.js';
import InviteService from '../services/inviteService.js';
import toast from '../services/toast.js';

export default {
  name: 'balance',
  data() {
    return {
      mobile_phone: -1,
      haswx: this.$route.query.haswx,
      inviteInfo: {},
      inviteService: new InviteService(this.$http),
    };
  },
  methods: {
    /**
     * 获取用户编号
     */
    getUID() {
      if (!this.$route.query.mobile_phone) {
        toast.show('缺少参数');
        return;
      }
      this.mobile_phone = parseInt(this.$route.query.mobile_phone);
    },

    /**
     * 获取邀请信息
     */
    getInviteInfo() {
      this.inviteService
        .queryUserInviteInfo(this.mobile_phone)
        .then((data) => {
          const result = data.body;
          if (result.ret === 0) {
            this.inviteInfo = result.body;
            this.shareDatas = this.inviteService.buildShareDateForBalancePage(
              this.inviteInfo,
              this.mobile_phone,
              this.$route.query.dev,
            );
          } else {
            toast.show(result.msg);
          }
        })
        .catch(() => {
          toast.show('获取失败');
        });
    },

    /**
     * 分享
     */
    share(type) {
      if (!this.inviteInfo) {
        toast.show('获取数据失败');
        return;
      }
      const me = this;
      utils.getBridge((bridge) => {
        bridge.callHandler('client_share', me.shareDatas[type], () => {});
      });
    },
  },
  mounted() {
    this.getUID();
    this.getInviteInfo();
  },
  created() {
    utils.setTitle('余额');
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  line-height: 1;
}

html,
body {
  height: 100%;
  width: 100%;
  background-color: white;
}

html {
  font-size: 625%;
}

@media screen and (min-width: 404px) {
  html {
    font-size: 690%;
  }
}

body {
  font-family: PingFang SC, Microsoft YaHei, Helvetica, Segoe UI, Lucida Grande,
    Helvetica, Arial, FreeSans, Arimo, Droid Sans, wenquanyi micro hei,
    Hiragino Sans GB, Hiragino Sans GB W3, FontAwesome, sans-serif;
  font-size: 0.16rem;
  color: #444;
  background-color: #fdfdfe;
}

img {
  max-width: 100%;
}

.invite-wrap {
  height: 100%;
  background-color: white;
}

.main {
  min-height: 100%;
  padding-bottom: 0.3rem;
}

.footer {
  display: none;
}

.header {
  position: relative;
  padding-top: 0;
  text-align: center;
  color: #909090;

  .h1 {
    margin-top: 0;
    color: #444;
    font-size: 0.16rem;
    margin-bottom: 0.18rem;
  }

  .h2 {
    margin-top: 0.08rem;
    font-size: 0.14rem;
  }
}

.title {
  text-align: center;
  margin-top: 0.43rem;
  font-size: 0.3rem;

  .ycode {
    border-bottom: 2px solid #333;
    display: inline-block;
    padding: 0 0.24rem 0.15rem 0.24rem;
  }
}

.price {
  .price-content {
    width: 1.67rem;
    height: 0.805rem;
    text-align: center;
    background: url(../../static/img/price.png) no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    font-size: 0.24rem;
    color: #ff5a60;
    padding-right: 0.12rem;

    span {
      line-height: 0.795rem;
      font-size: 0.36rem;
    }
  }
}

.info {
  color: #909090;
  font-size: 0.12rem;
  text-align: center;
  margin-top: 0.11rem;

  &:first-of-type {
    margin-top: 0.15rem;
  }
}

.h3 {
  color: #aaa;
  font-size: 0.14rem;
  text-align: center;
  margin-top: 0.58rem;

  span {
    color: #cfcfcf;
  }
}

.share {
  width: 2.5rem;
  text-align: center;
  margin: 0.26rem auto 0 auto;

  a {
    display: inline-block;

    &:first-of-type {
      float: left;
    }

    & + a + a {
      float: right;
    }

    &:only-of-type {
      float: none;
    }
  }

  img {
    width: 0.52rem;
    border-radius: 100%;
  }
}
</style>
